import { SimpleCollection } from '@/api'
import BaseStore from '@/store/BaseStore'
import { Module, Mutation } from 'vuex-module-decorators'

export interface ModalCollectionSelectInterface {
  collectionNo: string
  simpleCollections: SimpleCollection[]
  onClickOk?: (id: number) => void
  onClickCancel?: () => void
}

@Module({
  name: 'ModalCollectionSelectStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalCollectionSelectStore extends BaseStore {
  _isOpen: boolean = false

  _collectionNo: string = ''

  _simpleCollections: SimpleCollection[] = []

  _okCallback?: (id: number) => void

  _cancelCallback?: () => void

  get isOpen(): boolean {
    return this._isOpen
  }

  get collectionNo(): string {
    return this._collectionNo
  }

  get simpleCollections(): SimpleCollection[] {
    return this._simpleCollections
  }

  @Mutation
  public open(params?: ModalCollectionSelectInterface): void {
    this._isOpen = true
    this._collectionNo = params?.collectionNo ?? ''
    this._simpleCollections = params?.simpleCollections ?? []
    this._okCallback = params?.onClickOk
    this._cancelCallback = params?.onClickCancel
  }

  @Mutation
  public close() {
    this._isOpen = false
  }

  @Mutation
  public ok(id: number) {
    if (this._okCallback) {
      this._okCallback(id)
    }

    this._isOpen = false
  }

  @Mutation
  public cancel() {
    if (this._cancelCallback) {
      this._cancelCallback()
    }

    this._isOpen = false
  }
}
